<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col">
                    <h2>{{ title }}</h2>
                </div>
                <div class="col text-right">
                    <button @click.prevent="clear"
                            class="btn btn-primary">Pulisci
                    </button>
                    <button @click.prevent="search"
                            class="btn btn-success">Cerca
                    </button>
                </div>
            </div>

            <people-card-form :form="form" type="search" :advanced-search="true"/>

        </div>
    </section>
</template>

<script>
import sharedState from "../sharedState";
import PeopleCardForm from "../components/PeopleCardForm";
import peopleCards from "../services/api/peopleCards";

export default {
    name: "AdvancedSearchPeopleCard",
    components: {PeopleCardForm},
    data() {
        return {
            sharedState: sharedState,
            title: 'Ricerca avanzata schede persone',
            peopleCardId: null,
            form: new Form()
        }
    },
    methods: {
        async search() {
            this.$isLoading(true)
            let response = await peopleCards.advancedSearch(this.form)
            let ts = Date.now()
            sharedState.pushAdvancedSearchResults({
                ts: ts,
                type: 'people',
                ids: response.data.data.ids,
                searchKeys: response.data.data.searchKeys
            })
            this.$isLoading(false)
            await this.$router.push({path: '/advanced-search/people-cards/results/' + ts});
        },
        clear() {
            this.form = new Form()
        }
    }
}
</script>

<style scoped>

</style>
